import { PiSpinner } from "react-icons/pi";
import style from "./pageLoad.module.css";

const PageLoad = ({ isLoading = true, className }) => {
  return (
    <div
      className={`
      ${isLoading ? className : style.loaded} ${style.basicConf} ${
        className === "percents" ? style.nodeBackColor : ""
      }`}
    >
      <PiSpinner
        className={`${style.spinner} 
        ${className === "absolute" ? style.absolutePageLoad : ""}
        `}
      />
    </div>
  );
};

export default PageLoad;
